const isMedicationSelectionMissing = (
  isManufacturerCard: boolean,
  medication: string,
  hasMedicationList: boolean,
): boolean => {
  return (
    isManufacturerCard && hasMedicationList && medication === ''
  );
};

export default isMedicationSelectionMissing;
